<template>
  <div class="code-login">
    <div class="tip">未注册手机号验证后将自动注册</div>
    <a-form :form="loginForm">
      <a-form-item>
        <a-input
          v-decorator="[
            'phone',
            {
              rules: [
                { required: true, message: '请输入手机号', trigger: 'blur' },
                {
                  pattern: /^1\d{10}$/,
                  message: '请输入正确的手机号',
                  trigger: ['blur', 'change'],
                },
              ],
            },
          ]"
          placeholder="请输入手机号"
        >
          <img class="sjh" slot="prefix" src="@/assets/images/sj.png" alt="" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input
          v-decorator="['code', { rules: codeRules }]"
          placeholder="请输入验证码"
        >
          <img class="sjh" slot="prefix" src="@/assets/images/xj.png" alt="" />
          <div v-if="isCode" class="yzm-button yzm-disable" slot="suffix">
            {{ count }}秒后再获取
          </div>
          <div v-else class="yzm-button" slot="suffix" @click="getCaptcha">
            获取验证码
          </div>
        </a-input>
      </a-form-item>
    </a-form>
    <div class="login-button" @click="login">登 录</div>
    <div class="login-yhxy-box">
      <a-checkbox v-model="agree" @change="checkChange">
        我已阅读并同意<a href="/yhxy">《用户协议》</a>和<a href="">《隐私政策》</a>
      </a-checkbox>
    </div>

    <Verify
      ref="verify"
      mode="pop"
      captcha-type="blockPuzzle"
      :img-size="{ width: '330px', height: '155px' }"
      @success="verifySuccess"
    />
  </div>
</template>

<script>
import Verify from "@/components/Verifition/Verify.vue";
import { postCodeLogin, postSendCode } from "@/api/layout";
import { message } from "ant-design-vue";
export default {
  components: { Verify },
  data() {
    return {
      agree: false,
      loginForm: this.$form.createForm(this),
      captcha: undefined,
      isCode: false,
      count: 60,
      timer: null,
      codeRules: [
        { required: false, message: "请输入验证码", trigger: "blur" },
      ],
    };
  },
  methods: {
    login() {
      if (!this.agree) {
        this.$message.error("请先同意用户协议和隐私政策");
        return;
      }
      this.loginForm.validateFields((err) => {
        if (!err) {
          this.submitForm();
        }
      });
    },
    // 登录
    submitForm() {
      const data = {
        captcha: this.captcha,
        phone: this.loginForm.getFieldValue("phone"),
        code: this.loginForm.getFieldValue("code"),
      };
      postCodeLogin(data).then((res) => {
        if (res) {
          if (res.code === 200) {
            message.success(res.message || "登录成功");
            this.$emit("success", res.result);
          } else {
            message.error(res.message || "登录失败");
          }
        }
      });
    },
    // 获取验证码
    getCaptcha() {
      this.codeRules = [
        { required: false, message: "请输入验证码", trigger: "blur" },
      ];
      this.loginForm.validateFields((err) => {
        if (!err) {
          this.$refs.verify.show();
        }
      });
    },
    // 验证码获取成功
    verifySuccess(params) {
      this.captcha = params.captchaVerification;
      this.codeRules = [
        { required: true, message: "请输入验证码", trigger: "blur" },
      ];
      this.countdown();
      postSendCode({
        phone: this.loginForm.getFieldValue("phone"),
        captcha: this.captcha,
      }).then((res) => {
        if (res && res.code === 200) {
          message.success("验证码发送成功");
        } else {
          message.error(res.message || "验证码发送失败");
        }
      });
    },

    // 验证码倒计时
    countdown() {
      this.isCode = true;
      this.timer = setInterval(() => {
        this.count--;
        if (this.count <= 0) {
          clearInterval(this.timer);
          this.isCode = false;
          this.count = 60;
        }
      }, 1000);
    },
    checkChange(event) {
      this.agree = event.target.checked;
    },
  },
  beforeDestroy() {
    this.loginForm.resetFields();
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.code-login {
  margin-top: 25px;

  .sjh {
    width: 16px;
    height: 16px;
  }

  .tip {
    font-weight: 400;
    font-size: 14px;
    color: #dddddd;
    line-height: 24px;
  }

  .yzm-button {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 22px;

    &:hover {
      cursor: pointer;
    }
  }

  .yzm-disable {
    color: #d9d9d9;
  }

  .login-button {
    width: 340px;
    height: 40px;
    background-color: #0067db;
    border-radius: 2px;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      cursor: pointer;
    }
  }

  .login-yhxy-box {
    margin-top: 16px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 22px;
  }

  ::v-deep(.ant-input, .ant-input-affix-wrapper) {
    width: 340px;
    height: 40px;
    outline: none;
    box-shadow: none;
    border-radius: 2px;
    border: 1px solid #d9d9d9;
  }
}
</style>
